import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-block d-lg-inline-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg-nowrap me-0 me-lg-4 mb-2 mb-lg-0" }, " 本イベントはオンラインLIVE配信での開催です（アーカイブ配信はありません） ", -1)
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "icon icon-start icon-me-2 icon-login" }



  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginBox',
  props: {
    login: { type: Boolean },
    linkBaseURL: { type: String }
  },
  setup(__props) {

const props = __props;

  

  const openLink = (url: string) => {
    let target = '_blank';
    if (props.login) {
      target = '_self';
    }
    if (props.linkBaseURL) {
      url = props.linkBaseURL + url;
    }
    window.open(url, target, "noreferrer");
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["my-3 alert text-center fw-bold session-top-alert", __props.login ? 'alert-accent2' : 'alert-primary']),
    role: "alert"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "text-nowrap btn btn-accent2 text-decoration-none",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openLink('/mypage/')), ["stop","prevent"]))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(__props.login ? 'マイページ' : 'ログイン'), 1)
        ])
      ])
    ])
  ], 2))
}
}

})